import { areSomeAuthsRejected, currentAuths } from '../auths/authsControl'
import { REJECTED_REQUEST } from '../status/statusControl'

export function someAuthsRejectedStatus(request) {
  return {
    match: areSomeAuthsRejected(currentAuths(request)),
    status: REJECTED_REQUEST
  }
}
